import { Dialog } from 'components/dialog';
import { HeadingAddon } from './components/heading-addon';
import { DraftDialogFooter } from './components/draft-dialog-footer';
import { DraftsList } from './components/drafts-list';
import { IDraftDialog } from './types';
import { styles } from './styles';

export const DraftDialog = ({ open, drafts, onClose }: IDraftDialog) => {
  return (
    <Dialog sx={styles.dialog} open={open} onClose={onClose}>
      <Dialog.Header
        heading="Draft Posts"
        headingAddon={!!drafts.length && <HeadingAddon>{drafts.length}</HeadingAddon>}
      />
      <Dialog.Content sx={styles.dialogContent}>
        <DraftsList drafts={drafts} onClose={onClose} />
      </Dialog.Content>
      <Dialog.Footer>
        <DraftDialogFooter onCancel={onClose} />
      </Dialog.Footer>
    </Dialog>
  );
};
